import React from 'react';
import './TabPoliciesInfluence.less';

export default function TabPoliciesInfluence(props) {
  const { policies } = props.data;
  return (
    <div className="tab-policies-influence">
      <ul>
        {policies.map((item, i) =>
          <li key={i}>{item.name}</li>)}
      </ul>
    </div>
  );
}
